// API Configuration Constants
export const API_BASE_URL = 'https://myorderportalservice.com';

